module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-gallery u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative "
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-b-xxxl u-fit-w"
  }, [_c('section', {
    staticClass: "u-fit-w u-flex--x u-flex--center u-align-center u-flex--y@md"
  }, _vm._l((_vm.videoGames), function(game, index) {
    return _c('app-btn-filter', {
      key: index,
      staticClass: "u-flex--x u-block@md u-w2of3@md u-fit-w@sm u-marg-l-sm u-uppercase u-marg-x-auto@md u-marg-x-xxxs@lg",
      class: [_vm.filterVideoGame.id === parseInt(game.id, 10) ? 'is-selected' : ''],
      on: {
        "click": function($event) {
          _vm._onFilterVideoGame(parseInt(game.id, 10))
        }
      }
    }, [_c('h2', {
      staticClass: "u-inline-block u-fit"
    }, [_c('img', {
      staticClass: "is-img",
      attrs: {
        "src": game.logo_light || '/static/game/game-all.png',
        "alt": game.name,
        "title": game.name
      }
    })])])
  }))]), _vm._v(" "), (_vm.images.length > 0) ? _c('section', {
    staticClass: "c-page-gallery__images-container u-relative u-flex u-flex-jc--space-between u-flex-fw--wrap"
  }, [_c('div', {
    staticClass: "c-page-gallery__images-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black",
    class: [_vm.isFilterChanging ? 'is-filter-changing' : '']
  }), _vm._v(" "), (_vm.$root.width > 940) ? _c('div', {
    staticClass: "u-flex u-flex-jc--center u-fit-w"
  }, [_c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--left u-w1of3"
  }, _vm._l((_vm.images), function(image, index) {
    return (index % 3 === 0) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      class: [index < 3 ? 'is-first-line' : ''],
      attrs: {
        "delay": index * 70,
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--middle u-w1of3"
  }, _vm._l((_vm.images), function(image, index) {
    return (index % 3 === 1) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      class: [index < 3 ? 'is-first-line' : ''],
      attrs: {
        "delay": index * 70 + (70 / 6 * 1),
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--right u-w1of3"
  }, _vm._l((_vm.images), function(image, index) {
    return (index % 3 === 2) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      class: [index < 3 ? 'is-first-line' : ''],
      attrs: {
        "delay": index * 70 + (70 / 6 * 2),
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])]) : _vm._e()
  }))]) : (_vm.$root.width > 770) ? _c('div', {
    staticClass: "u-flex u-flex-jc--center u-fit-w"
  }, [_c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--left u-w1of2"
  }, _vm._l((_vm.images), function(image, index) {
    return (index % 2 === 0) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      class: [index < 2 ? 'is-first-line' : ''],
      attrs: {
        "delay": index * 70,
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--right u-w1of2"
  }, _vm._l((_vm.images), function(image, index) {
    return (index % 2 === 1) ? _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      class: [index < 2 ? 'is-first-line' : ''],
      attrs: {
        "delay": index * 70 + (70 / 6 * 1),
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])]) : _vm._e()
  }))]) : _c('div', {
    staticClass: "u-flex u-flex-jc--center u-fit-w"
  }, [_c('div', {
    staticClass: "c-page-gallery__images-container__column u-fit-w"
  }, _vm._l((_vm.images), function(image, index) {
    return _c('app-fadein', {
      key: index,
      staticClass: "c-page-gallery__images-container__single u-pad-a-xs u-pad-a-0@md u-pad-y-xs@md u-cursor-pointer",
      attrs: {
        "delay": index * 35,
        "move": index === 1 && _vm.images.length === 3 ? 0 : -50
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm._clickOnImage(index)
        }
      }
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container u-relative u-overflow-h"
    }, [_c('div', {
      staticClass: "c-page-gallery__images-container__single__cover-container__overlay u-absolute u-pos-tl u-index--2 u-fit u-bg--black"
    }), _vm._v(" "), _c('app-img-bg', {
      staticClass: "c-page-gallery__images-container__single__cover-container__cover u-index--1",
      attrs: {
        "src": image.src,
        "size": "cover"
      }
    })], 1)])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.images.length === 0) ? _c('section', {
    staticClass: "c-page-gallery__images-container u-flex u-flex-jc--center"
  }, [(_vm.$root.width > 940) ? _c('div', {
    staticClass: "u-flex u-flex-jc--center u-fit-w"
  }, [_c('div', {
    staticClass: "c-page-gallery__images-container__column c-page-gallery__images-container__column--left"
  }, [_vm._v("\n                    " + _vm._s(_vm.contentPage.taxonomies.noImages) + "\n                ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isMoreBtnEnable) ? _c('div', {
    staticClass: "u-marg-t-xxl u-align-center"
  }, [_c('app-btn', {
    on: {
      "click": function($event) {
        _vm._moreImages()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentPage.taxonomies.moreImages)
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.images.length > 0) ? _c('app-gallery-slideshow', {
    class: [_vm.isSlideshowTranslating ? 'is-translating' : ''],
    attrs: {
      "is-active": !_vm.isSlideshowHidden,
      "images": _vm.images,
      "active-image": _vm.slideshowActiveImage,
      "content-page": _vm.contentPage
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf67266"}!./src/scripts/components/page-gallery/template.html
// module id = 933
// module chunks = 0